
const parse = (number) => {
    number = String(number)
        .replace(/ /g, '')
        .replace(/-/g, '')

    return {
        number: number,
        countryCode: 0,

        format: function () {
            return this.number
        },

        isValid: function () {
            return this.validate().length === 0
        },

        isDummyNumber: function () {
            if (isNaN(this.number)) {
                return false
            }
            if (this.number.length !== 8) {
                return false
            }
            if (this.number.charAt(0) !== '7') {
                return false
            }
            return true
        },

        validate: function () {
            if (!this.isDummyNumber()) {
                // Copied result from TABScommon isDummy check
                return ['none dummy']
            }
            return []
        },
    }
}

export default {
    parse,
}